export default __webpack_public_path__ + "static/cpp-7fa8076c679eb4dcae5a2cddcf2c5bd1.jpg";